import { makeStyles } from '@material-ui/core';

export const styles = () => ({
  groupDetails: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#313D44',
    margin: 0
  },
  groupName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: '#313D44',
    margin: 0,
  }
});

export default makeStyles(styles);